import React, { Component } from 'react';

export class LoginContentPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            record: props.record
        };
    }
    render() {
        return (
            <div>
                <div class="form-group">
                    <div class="form-row">
                        <label class="col-md-2">Usuario</label>
                        <input name="Usuario" type="text" className="form-control form-control-sm col-md-4" />
                    </div>
                </div>
                <div class="form-group">
                    <div className="form-row">
                        <label class="col-md-2">Contraseña</label>
                        <input name="Clave" type="password" className="form-control form-control-sm col-md-4" />
                    </div>
                </div>
            </div>
        );
    }
}

